import useSWR from 'swr'

import { getMultipleStops } from '../data/network.api'
import { IRTIS3_REFRESH_INTERVAL } from '../constants'

export function useMultipleStops({
  stopIds,
  shouldFetch = true,
}: {
  stopIds: string[]
  shouldFetch?: boolean
}) {
  const { data, error, isLoading } = useSWR(
    shouldFetch && `stops-${stopIds.join('+')}`,
    () => getMultipleStops(stopIds),
    {
      fallbackData: [],
      revalidateOnFocus: false,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        const errorTimeoutId = setTimeout(() => {
          revalidate({ retryCount })
          clearTimeout(errorTimeoutId)
        }, IRTIS3_REFRESH_INTERVAL)
      },
    },
  )

  return {
    stops: data,
    error,
    isLoading,
  }
}
